module.exports = "<p>格式化输出</p>\n";